import React from 'react'

import PropTypes from 'prop-types'

import IsModelessContext from './IsModelessContext'


// Every `Dialog` below this renders without taking over the page. It has to be
// a context rather than a prop, because views reach `Dialog` through
// `DisplayManager`, and the buttons inside one view push the next one without
// knowing anything about where the app is mounted.
//
// The value is the literal `true` rather than a prop, which makes this a
// marker: the only thing a caller can do is switch its own subtree to modeless.
// Nothing needs to switch it back, and since `IsModelessContext` never leaves
// this directory, nothing can. A literal is also the same value on every
// render, so consumers never re-render on account of this provider.
//
export default function IsModelessProvider({ children }) {
  return (
    <IsModelessContext.Provider value={ true }>
      { children }
    </IsModelessContext.Provider>
  )
}

IsModelessProvider.propTypes = {
  children: PropTypes.node,
}
